import { VisuallyHidden } from 'radix-ui';
import { useMemo } from 'react';

import {
  MermaidDiagramView,
  getCachedMermaidDiagram,
} from '@/components/ui/smoothdown/components/StaticCode/MermaidDiagramView';
import { settingsStore } from '@/stores/settings.store';

import { Dialog } from '../ui/dialog';

import { type ModalFC } from './modalsManager';

interface MermaidPreviewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  content: string;
}

export const MermaidPreviewModal: ModalFC<MermaidPreviewModalProps> = ({
  open,
  onOpenChange,
  content,
}) => {
  const diagram = useMemo(
    () =>
      open
        ? getCachedMermaidDiagram(content, settingsStore.dyslexicFont)
        : null,
    [open, content]
  );

  const copyText = useMemo(
    () => `\`\`\`mermaid\n${content}\n\`\`\``,
    [content]
  );

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content
        showCloseButton
        className="max-w-[90vw] max-h-[90vh] w-[90vw] h-[85vh] p-0 overflow-hidden !left-0 !right-0 !top-0 !bottom-0 !translate-x-0 !translate-y-0 !m-auto"
      >
        <VisuallyHidden.Root>
          <Dialog.Title>Mermaid diagram preview</Dialog.Title>
        </VisuallyHidden.Root>
        {diagram && (
          <MermaidDiagramView
            diagram={diagram}
            copyText={copyText}
            interactive
            className="rounded-xl"
          />
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};
